import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../services/api';

const formatDateTime = (value) => {
  if (!value) return 'Never';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'Never';
  return parsed.toLocaleString();
};

const ROLE_LABELS = {
  'role-acct-mgmt': 'Account Management',
  'role-key-mgmt': 'Key Management',
  'role-support': 'Support',
};

const OpsOrgUsers = () => {
  const { orgId } = useParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const loadUsers = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await api.get(`/acct-mgmt/v1/orgs/${orgId}/users`);
        if (!mounted) return;
        setUsers(response.data?.users || []);
      } catch (err) {
        if (!mounted) return;
        setError(err.response?.data?.error || 'Failed to load organization users');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (orgId) loadUsers();
    return () => {
      mounted = false;
    };
  }, [orgId]);

  return (
    <div>
      <h2 className="h4 fw-bold mb-1">Organization Users</h2>
      <p className="text-muted mb-3">View user access, roles, and recent login activity.</p>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Users</h5>
          {loading && <div className="text-muted">Loading users...</div>}
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
          {!loading && !error && users.length === 0 && <div className="text-muted">No users found.</div>}
          {!loading && users.length > 0 && (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Email</th>
                    <th>Roles</th>
                    <th>Last Login</th>
                    <th>Failed Logins</th>
                    <th>Last Failed Login</th>
                    <th>Internal</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td>{user.full_name || '—'}</td>
                      <td>{user.email}</td>
                      <td>
                        {(user.roles || []).length === 0 ? (
                          '—'
                        ) : (
                          (user.roles || []).map((role) => (
                            <span
                              key={role}
                              className={`badge ${role === 'role-support' ? 'bg-success text-white' : 'bg-light text-dark border'} me-1`}
                            >
                              {ROLE_LABELS[role] || role}
                            </span>
                          ))
                        )}
                      </td>
                      <td>{formatDateTime(user.last_login_at)}</td>
                      <td>{user.failed_login_count ?? 0}</td>
                      <td>{formatDateTime(user.last_failed_login_at)}</td>
                      <td>{user.is_internal ? 'Yes' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpsOrgUsers;
